import { ErrorPopup } from "mobily-ui-library";
import { useGlobalStore } from "../stores/globalStore";
import { useShallow } from "zustand/shallow";

export const APIError = () => {
    const { setApiError, apiError } = useGlobalStore(
        useShallow((state) => ({
            setApiError: state.setApiError,
            apiError: state.apiError,
        }))
    );
    return (
        <div className='apiErrorWrapper'>
            {
                <ErrorPopup
                    errorText={apiError?.message ?? ''}
                    tryAgainText={apiError?.retryText ?? ''}
                    closeText={apiError?.cancelText ?? ''}
                    onClose={() => setApiError({ isError: false })}
                    onRetry={() => {
                        const productKey = sessionStorage.getItem('productKey');
                        const productURL = sessionStorage.getItem('productURL');

                        if (productKey) {
                            window.location.reload();
                            setApiError({ isError: false });
                            return;
                        }

                        if (productURL) {
                            window.location.href = productURL;
                            setApiError({ isError: false });
                            return;
                        }

                        const referrer = document.referrer;
                        const sameOrigin = referrer && referrer.startsWith(window.location.origin);

                        if (sameOrigin && window.history.length > 1) {
                            window.history.back();
                        } else {
                            window.location.href = '/';
                        }
                    }}
                />
            }
        </div>
    )
}